import React, { useRef, useState } from "react";
import "./viewtemplate.css";
import CommonLoaderBlue from "../../../../../../components/Loader/LoaderBlue";
import { Button } from "primereact/button";
import { splitCamelCase } from "../../../../../../../utility";
import { Toast } from "primereact/toast";
import { api } from "../../../../../../../utility/AxiosInceptor";
import { useNavigate } from "react-router-dom";

export default function ViewTemplateDetails({
  setRefreshTemplateData,
  handleCreateTemplate,
  setFieldValue,
  isEdit,
  isFromhome,
  setCurrentActiveScreen,
  values,
  currentSelectedRow,
  setShowViewTemplate,
}) {
  const [isLoading, setisLoading] = useState(false);
  const navigate = useNavigate();
  let toaster = useRef(null);
  function handleCreateTemplateApi() {
    setisLoading(true);
    if (isEdit) {
      api
        .put(
          `/api/web/reportDownload/update-template?reportId=${currentSelectedRow._id}`,
          convertToBackendFormat()
        )
        .then((res) => {
          toaster.current.show({
            severity: "success",
            summary: "Template Updation",
            detail: res?.data?.msg,
          });
          if (!isFromhome) {
            setTimeout(() => {
              setCurrentActiveScreen({
                isDelete: false,
                isEdit: false,
                isDownload: false,
              });

              setRefreshTemplateData((prev) => !prev);
            }, 500);
          }
        })
        .catch((err) => {
          toaster.current.show({
            severity: "error",
            summary: "TemplateUpdation",
            detail: err?.response?.data?.msg || "Template Creation Failed",
          });
        });
    } else {
      api
        .post(`/api/web/reportDownload/create`, convertToBackendFormat())
        .then((res) => {
          toaster.current.show({
            severity: "success",
            summary: "Template Creation",
            detail: res?.data?.msg,
          });

          setTimeout(() => {
            if (!isFromhome) {
              handleCreateTemplate();
              setRefreshTemplateData((prev) => !prev);
            } else {
              navigate("/reports-downloads");
            }
          }, 500);
        })
        .catch((err) => {
          toaster.current.show({
            severity: "error",
            summary: "Template Creation",
            detail: err?.response?.data?.msg || "Template Creation Failed",
          });
        });
    }
  }
  function convertToBackendFormat() {
    return {
      createdBy: JSON.parse(localStorage.getItem("userData"))._id, // or dynamic
      reportName: values.templateName,

      personalDetails: {
        isFirstName:
          values.templatePersonalDetailsOptions.includes("firstName"),
        isLastName: values.templatePersonalDetailsOptions.includes("lastName"),
        isMiddleName:
          values.templatePersonalDetailsOptions.includes("middleName"),
        isSufix: values.templatePersonalDetailsOptions.includes("suffix"),
        isSSN: values.templatePersonalDetailsOptions.includes("ssn"),
        isDOB: values.templatePersonalDetailsOptions.includes("dob"),
        isContact: values.templatePersonalDetailsOptions.includes("contact"),
        isEmail: values.templatePersonalDetailsOptions.includes("email"),
        isAlternateContact:
          values.templatePersonalDetailsOptions.includes("alternateContact"),
        isAddress1: values.templatePersonalDetailsOptions.includes("address1"),
        isAddress2: values.templatePersonalDetailsOptions.includes("address2"),
        isZipCode: values.templatePersonalDetailsOptions.includes("zipCode"),
        isMailingAddress1:
          values.templatePersonalDetailsOptions.includes("mailingAddress1"),
        isMailingAddress2:
          values.templatePersonalDetailsOptions.includes("mailingAddress2"),
        isCity: values.templatePersonalDetailsOptions.includes("city"),
        isState: values.templatePersonalDetailsOptions.includes("state"),
        isMailingCity:
          values.templatePersonalDetailsOptions.includes("mailingCity"),
        isMailingState:
          values.templatePersonalDetailsOptions.includes("mailingState"),
        isPoBox: values.templatePersonalDetailsOptions.includes("poBox"),
        isAccountId:
          values.templatePersonalDetailsOptions.includes("accountId"),
        isEnrollmentId:
          values.templatePersonalDetailsOptions.includes("enrollmentId"),
      },

      dates: {
        isOrderCreateDate:
          values.templateDateParametersOptions.includes("orderCreateDate"),
        isApprovalDate:
          values.templateDateParametersOptions.includes("approvalDate"),
        isRejectDate:
          values.templateDateParametersOptions.includes("rejectionDate"),
        isEsnAssignDate:
          values.templateDateParametersOptions.includes("esnAssignDate"),
        isLabelCreateDate:
          values.templateDateParametersOptions.includes("labelCreateDate"),
        isInvoiceCreateDate:
          values.templateDateParametersOptions.includes("invoiceCreateDate"),
        isInvoiceAdjustmentDate: values.templateDateParametersOptions.includes(
          "invoiceAdjustmentDate"
        ),
        isInvoiceVoidedDate:
          values.templateDateParametersOptions.includes("invoiceVoidedDate"),
        isAdHocInvoiceDate:
          values.templateDateParametersOptions.includes("adHocInvoiceDate"),
        isLabelPrintDate:
          values.templateDateParametersOptions.includes("labelPrintDate"),
        isPackageDeliveredDate: values.templateDateParametersOptions.includes(
          "packageDeliveryDate"
        ),
        isEsnActivationDate:
          values.templateDateParametersOptions.includes("esnActivationDate"),
        isAccountActivationDate: values.templateDateParametersOptions.includes(
          "accountActivationDate"
        ),
        isPlanConfiguredDate:
          values.templateDateParametersOptions.includes("planConfiguredDate"),
        isPlanActivationDate:
          values.templateDateParametersOptions.includes("planActivationDate"),
        isPlanExpirationDate:
          values.templateDateParametersOptions.includes("planExpirationDate"),
        isDisconnectionDate:
          values.templateDateParametersOptions.includes("disconnectionDate"),
        isDisconnectionReason: values.templateDateParametersOptions.includes(
          "disconnectionReason"
        ),
      },

      planInformation: {
        isEsnNumber: values.templatePlanInfoOptions.includes("esnNumber"),
        isImeiNumber: values.templatePlanInfoOptions.includes("imei"),
        isMdn: values.templatePlanInfoOptions.includes("mdn"),
        isPlanName: values.templatePlanInfoOptions.includes("planName"),
        isPlanCode: values.templatePlanInfoOptions.includes("planCode"),
        isPwgCustomerId:
          values.templatePlanInfoOptions.includes("pwgCustomerId"),
        isCarrier: values.templatePlanInfoOptions.includes("carrier"),
        isLineStatus: values.templatePlanInfoOptions.includes("lineStatus"),
      },

      miscellaneous: {
        isSalesCreatedBy:
          values.templateMiscallenousOptions.includes("saleCreatedBy"),
        isSalesCompletedBy:
          values.templateMiscallenousOptions.includes("saleCompletedBy"),
        isEsnAssignedBy:
          values.templateMiscallenousOptions.includes("esnAssignedBy"),
        isEsnActivatedBy:
          values.templateMiscallenousOptions.includes("esnActivatedBy"),
        isInvoicesGeneratedBy:
          values.templateMiscallenousOptions.includes("invoiceGeneratedBy"),
        isInvoicePaidBy:
          values.templateMiscallenousOptions.includes("invoicePaidBy"),
        isInvoiceVoidedBy:
          values.templateMiscallenousOptions.includes("invoiceVoidedBy"),
        isInvoiceAdjustedBy:
          values.templateMiscallenousOptions.includes("invoiceAdjustedBy"),
        isAdHocInvoiceAddedBy: values.templateMiscallenousOptions.includes(
          "adHocInvoiceAddedBy"
        ),
        isLabelCreatedBy:
          values.templateMiscallenousOptions.includes("labelCreatedBy"),
        isLabelPrintedBy:
          values.templateMiscallenousOptions.includes("labelPrintedBy"),
        isPackageDeliveredBy:
          values.templateMiscallenousOptions.includes("packageDeliveredBy"),
        isAccountActivatedBy:
          values.templateMiscallenousOptions.includes("accountActivatedBy"),
        isPlanActivatedBy:
          values.templateMiscallenousOptions.includes("planActivatedBy"),
        isPlanConfiguredBy:
          values.templateMiscallenousOptions.includes("planConfiguredBy"),
        isPlanChangeBy:
          values.templateMiscallenousOptions.includes("planChangedBy"),
        isDisconnectedBy:
          values.templateMiscallenousOptions.includes("disconnectedBy"),
      },
    };
  }

  return (
    <>
      <div
        style={{
          position: "fixed",
          zIndex: 1001,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#FFFFFF99",
          top: 0,
          left: 0,
        }}
      ></div>
      <div className="view-template-container flex flex-wrap flex-row justify-content-center">
        <div className="main-view-template flex flex-column ">
          <div className="top-view-template">
            <div className="view-template-header flex flex-column align-items-center justify-content-center">
              <h1 className="view-template-header-title">
                Preview Your Report Template
              </h1>
              <p className="view-template-header-subtitle">
                Review your selected filters and data fields below before
                finalizing the template. All selected items will appear in your
                downloaded report.
              </p>
            </div>
            <div className="main-details">
              <h1>Dates Parameters</h1>
              <div className="details-show">
                {values.templateDateParametersOptions.map((item, index) => (
                  <div key={index} className="detail-item-main">
                    {" "}
                    <p>{splitCamelCase(item)}</p>
                    <i
                      onClick={() => {
                        const updated = [
                          ...values.templateDateParametersOptions,
                        ];
                        updated.splice(index, 1);
                        setFieldValue("templateDateParametersOptions", updated);
                      }}
                      className="pi pi-times"
                    />
                  </div>
                ))}
              </div>
            </div>

            <div className="main-details">
              <h1>Personal Details</h1>
              <div className="details-show">
                {values.templatePersonalDetailsOptions.map((item, index) => (
                  <div key={index} className="detail-item-main">
                    {" "}
                    <p>{splitCamelCase(item)}</p>
                    <i
                      onClick={() => {
                        const updated = [
                          ...values.templatePersonalDetailsOptions,
                        ];
                        updated.splice(index, 1);
                        setFieldValue(
                          "templatePersonalDetailsOptions",
                          updated
                        );
                      }}
                      className="pi pi-times"
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="main-details">
              <h1>Plan Info</h1>
              <div className="details-show">
                {values.templatePlanInfoOptions.map((item, index) => (
                  <div key={index} className="detail-item-main">
                    {" "}
                    <p>{splitCamelCase(item)}</p>
                    <i
                      onClick={() => {
                        const updated = [...values.templatePlanInfoOptions];
                        updated.splice(index, 1);
                        setFieldValue("templatePlanInfoOptions", updated);
                      }}
                      className="pi pi-times"
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="main-details">
              <h1>Miscellaneous</h1>
              <div className="details-show">
                {values.templateMiscallenousOptions.map((item, index) => (
                  <div key={index} className="detail-item-main">
                    {" "}
                    <p>{splitCamelCase(item)}</p>
                    <i
                      onClick={() => {
                        const updated = [...values.templateMiscallenousOptions];
                        updated.splice(index, 1);
                        setFieldValue("templateMiscallenousOptions", updated);
                      }}
                      className="pi pi-times"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="action-buttons-container flex flex-wrap flex-row justify-content-end">
            <Button
              disabled={isLoading}
              onClick={() => {
                setShowViewTemplate((prev) => !prev);
              }}
              label="Back"
            />
            <Button
              onClick={handleCreateTemplateApi}
              disabled={isLoading}
              label={
                isLoading ? (
                  <div className="flex flex-wrap flex-row justify-content-center align-items-center">
                    <CommonLoaderBlue sizehere={12} color={"white"} />
                  </div>
                ) : isEdit ? (
                  "Update"
                ) : (
                  "Create"
                )
              }
            />
          </div>
        </div>
        <Toast ref={toaster} />
      </div>
    </>
  );
}
